import styled from 'styled-components';

export const TableTitleWrapper = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const TableContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  border-top: 1px solid ${({ theme }) => theme.colors.black3};
  border-left: 1px solid ${({ theme }) => theme.colors.black3};
  border-right: 1px solid ${({ theme }) => theme.colors.black3};
  overflow: hidden;
`;

export const TableContentItem = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
`;

export const TableContentItemTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.colors.black1};
  padding: 8px 16px;
  width: 100%;
  max-width: 256px;
`;

export const TableContentItemValue = styled.span`
  font-size: 14px;
  font-weight: 400;
  padding: 8px 16px;
`;
